export default "__VITE_ASSET__81204882__"